import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTemporadaTarifasComponent } from "./edit-temporada-tarifas/edit-temporada-tarifas.component";

@Component({
  selector: "app-temporada-tarifas",
  templateUrl: "./temporada-tarifas.component.html",
  styleUrls: ["./temporada-tarifas.component.scss"],
})
export class TemporadaTarifasComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTemporadaTarifasComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
